import RouteEnum from "constants/RouteEnum";
import React, { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import AuthRoute from "views/components/router-components/auth-route/Auth-Route";
import PublicRoute from "views/components/router-components/public-route/PublicRoute";
import AuthGuard from "views/components/guards/AuthGuard";
import PrivateLayout from "views/components/layouts/PrivateLayout";

const HomePage = lazy(() => import("views/home-page/HomePage"));
const LoginPage = lazy(() => import("views/auth-page/login-page/LoginPage"));
const RegisterPage = lazy(() => import("views/auth-page/register-page/RegisterPage"));
const VerifyEmailPage = lazy(() => import("views/auth-page/verify-email-page/VerifyEmailPage"));
const ResetPasswordPage = lazy(() => import("views/auth-page/reset-password-page/ResetPasswordPage"));
const ResendEmailPage = lazy(() => import("views/auth-page/resend-email-page/ResendEmailPage"));
const ConfirmPasswordPage = lazy(() => import("views/auth-page/confirm-password-page/ConfirmPasswordPage"));
const ReportPages = lazy(() => import("views/reports-pages/ReportPages"));
const ProjectPages = lazy(() => import("views/project-pages/ProjectPages"));
const ProfilePages = lazy(() => import("views/profile-pages/ProfilePages"));
const ActorPages = lazy(() => import("views/actor-pages/ActorPages"));
const CompaniesPages = lazy(() => import("views/companies-pages/CompaniesPages"));
const AboutPage = lazy(() => import("views/about-page/AboutPage"));
const ContactPage = lazy(() => import("views/contact-page/ContactPage"));
const InvitationMemberPage = lazy(() => import("views/auth-page/invitation-member-page/InvitationMemberPage"));
const NotificationPages = lazy(() => import("views/notifications-page/NotificationPages"));
const RoleApplicationMeetingEvaluationPage = lazy(
  () => import("views/role-application-meeting-evaluation-page/RoleApplicationMeetingEvaluationPage"),
);

const Routers: React.FC = () => {
  return (
    <Routes>
      <Route path={RouteEnum.Login} element={<AuthRoute><LoginPage /></AuthRoute>} />
      <Route path={RouteEnum.Register} element={<AuthRoute><RegisterPage /></AuthRoute>} />
      <Route path={RouteEnum.VerifyEmail} element={<VerifyEmailPage />} />
      <Route path={RouteEnum.InvitationMember} element={<InvitationMemberPage />} />
      <Route path={RouteEnum.ResendEmail} element={<ResendEmailPage />} />
      <Route path={RouteEnum.ResetPasswordConfirm} element={<ConfirmPasswordPage />} />
      <Route path={RouteEnum.ResetPassword} element={<ResetPasswordPage />} />

      {/* Protected routes with header */}
      <Route element={<AuthGuard />}>
        <Route element={<PrivateLayout />}>
          {/* redux: auth.selectedProfile === "cast_agency_employees" */}
          {/* redux: auth.selectedProfile === "production_company_employees" */}
          <Route path={RouteEnum.Reports + "/*"} element={<ReportPages />} />
          <Route path={RouteEnum.Profile + "/*"} element={<ProfilePages />} />
          <Route path={RouteEnum.Projects + "/*"} element={<ProjectPages />} />
          <Route path={RouteEnum.Actors + "/*"} element={<ActorPages />} />
          <Route path={RouteEnum.Companies + "/*"} element={<CompaniesPages />} />
          <Route path={RouteEnum.Notifications + "/*"} element={<NotificationPages />} />
          <Route path={RouteEnum.RoleApplicationMeetingEvaluation} element={<RoleApplicationMeetingEvaluationPage />} />
        </Route>
      </Route>

      <Route path={RouteEnum.ContactPage} element={<PublicRoute><ContactPage /></PublicRoute>} />
      <Route path={RouteEnum.AboutPage} element={<PublicRoute><AboutPage /></PublicRoute>} />
      <Route path={RouteEnum.Home} element={<PublicRoute><HomePage /></PublicRoute>} />
    </Routes>
  );
};

export default Routers;
